type EmptyStateProps = {
  title: string;
};

export function EmptyState({ title }: EmptyStateProps) {
  return <div className="rounded-md border border-dashed bg-panel px-4 py-8 text-center text-sm text-muted-foreground">{title}</div>;
}
